import { render, staticRenderFns } from "./tele-health.vue?vue&type=template&id=0ce932f8&scoped=true&"
import script from "./tele-health.vue?vue&type=script&lang=js&"
export * from "./tele-health.vue?vue&type=script&lang=js&"
import style0 from "./tele-health.vue?vue&type=style&index=0&id=0ce932f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce932f8",
  null
  
)

component.options.__file = "tele-health.vue"
export default component.exports